export default class URLParser {
  constructor(url) {
    const modifiedURL = url.toLowerCase().replace(/.*:\/\//, 'http://')
    const urlObject = new URL(modifiedURL)
    this.hostname = urlObject.hostname
    this.pathname = urlObject.pathname
    this.searchParams = urlObject.searchParams
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/URLParser.js